import * as types from 'constants/ActionTypes';
import { MEDIAS_API_UPLOAD } from 'constants/ApiConstants';

/** @type {import('./types').ReorderRequestAction} */
export const updateMediasOrderRequest = (data, meta = {}) => ({
  type: types.UPDATE_INTERVENTION_MEDIA_ORDER_REQUEST,
  payload: {
    request: {
      url: `${MEDIAS_API_UPLOAD}/reorder`,
      method: 'PATCH',
      data,
    },
  },
  meta,
});

/** @type {import('./types').ReorderRequestSuccessAction} */
export const updateMediasOrderSuccess = (meta = {}) => ({
  type: types.UPDATE_INTERVENTION_MEDIA_ORDER_SUCCESS,
  meta,
});

/** @type {import('./types').ReorderRequestFailureAction} */
export const updateMediasOrderFailure = (error, meta = {}) => ({
  type: types.UPDATE_INTERVENTION_MEDIA_ORDER_FAILURE,
  payload: error,
  error: true,
  meta
});
